<template>
  <div class="compCertTool column">
    <div class="title row align-center">
      <div class="grid-3">
        <select class="input" v-model="option" @change="load()"
          style="box-shadow: none;border-bottom: 1px solid #ddd;border-radius: 0;">
          <option value="especialidades">Especialidades</option>
          <option value="certificados">Certificados</option>
          <option value="ferramentas">Ferramentas</option>
        </select>
      </div>
      <div class="grid-9 row justify-end">ESPECIALIDADES, CERTIFICADOS E FERRAMENTAS</div>
    </div>
    <div class="grid-12">
      <div v-if="loader" class="grid-12 text-center" style="margin-top: 100px">
        <Loader />
      </div>
      <Tree v-else :tree="tree" />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Loader from "@/components/Loader";
import Tree from "@/components/Tree.vue";

export default {
  name: "CertficateTool",
  components: { Tree, Loader },
  data() {
    return { option: "especialidades", loader: true, tree: {} };
  },
  methods: {
    ...mapActions("admin", ["ESPECIALIDADES_LIST", "CERTIFICATER_LIST", "TOOLTYPE_LIST"]),
    async load() {
      this.loader = true
      if (this.option == "especialidades") this.tree = await this.ESPECIALIDADES_LIST()
      if (this.option == "certificados") this.tree = await this.CERTIFICATER_LIST();
      if (this.option == "ferramentas") this.tree = await this.TOOLTYPE_LIST();
      this.tree.reload = this.load
      this.loader = false
    },
  },
  beforeMount() { this.load() },
  mounted() {
    this.$parent.$children[0].changeMenu("compCertTool");
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.compCertTool {
  padding: 42px 35px;

  @media (max-width: $small) {
    padding: 7px;
  }

  .title {
    background: $white;
    box-shadow: $shadow;
    padding: 9px;
    border-radius: 19px 19px 0 0;
    font-size: 17px;
    color: $gray-4;
    font-weight: bold;
    letter-spacing: 0.7px;
    padding-right: 22px;
    margin-right: 14px;

    select {
      font-size: 23px;
      color: $client-2;
    }
  }
}
</style>